import AOS from 'aos';

AOS.init({
  duration: 600,
  once: true
});